import { Component, h } from 'preact';
import { I } from 'intl';

class TcrMessageBox extends Component
{
    constructor(params)
    {
        super(params);

        I.Ok = { de: 'OK', en: 'OK', sl: 'V redu', it: 'OK' };
        I.Cancel = { en: 'Cancel', de: 'Abbrechen', sl: 'Prekliči', it: 'Annulla' };

        this.show = this.show.bind(this);
        this.click = this.click.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.state = {};
    }

    componentDidMount()
    {
        window.MessageBox = {
            show: this.show
        };
    }

    show(options)
    {
        return new Promise((resolve) => {
            let state = {
                visible: true,
                input: false,
                title: '',
                text: '',
                value: '',
                validation: undefined,
                invalid: undefined,
                actions: [{title: 'OK', default: true}],
                autoFocus: true,
                next: resolve
            };
            if (options.title) state.title = options.title;
            if (options.text) state.text = options.text;
            if (options.input) state.input = true;
            if (options.value) state.value = options.value;
            if (options.validation) state.validation = options.validation;
            if (options.actions) state.actions = options.actions;
            this.setState(state, () => {
                if (this.ref) this.ref.focus();
            });
        });
    }

    click(index)
    {
        let next = this.state.next;
        this.setState({visible: false, next: undefined, autoFocus: false});
        if (typeof next === 'function')
        {
            if (this.state.input)
            {
                next({ action: index, value: this.state.value });
            }
            else
            {
                next(index);
            }
        }
    }

    onInput(e)
    {
        let value = e.target.value;
        let invalid = false;
        if (this.state.validation)
        {
            invalid = !value.match(this.state.validation);
        }
        this.setState({value: value, invalid: invalid});
    }

    onKeyDown(e)
    {
        //return or enter
        if (e.keyCode == 13)
        {
            e.preventDefault();
            e.stopPropagation();
            for (let i = 0; i < this.state.actions.length; i++)
            {
                if (this.state.actions[i].default)
                {
                    this.click(i);
                    break;
                }
            }
        }

        //escape
        if (e.keyCode == 27)
        {
            e.preventDefault();
            e.stopPropagation();
            for (let i = 0; i < this.state.actions.length; i++)
            {
                if (this.state.actions[i].cancel)
                {
                    this.click(i);
                    break;
                }
            }
        }
    }

    render()
    {
        if (!this.state.visible) return;
        
        let actions = this.state.actions.map((a, i) => {
            let classes = 'button';
            if (a.secondary) classes += ' secondary';
            return <div class={classes} data-index={i} onClick={(e) => this.click(parseInt(e.currentTarget.dataset.index) || 0)}>{a.title}</div>;
        });

        let input;
        if (this.state.input)
        {
            input = <input type="text" ref={(dom) => { this.ref = dom; }} autoFocus={true} value={this.state.value} onInput={this.onInput} onKeyDown={this.onKeyDown} data-invalid={this.state.invalid} />;
        }

        return (
            <div class="messagebox">
                <div class="panel">
                    <div class="title">{this.state.title}</div>
                    <div class="text" style="white-space: pre-wrap;">{this.state.text}</div>
                    {input}
                    <div class="actions">
                        {actions}
                    </div>
                </div>
            </div>
        );
    }
}

export { TcrMessageBox };